import {combineReducers} from 'redux';

import tax from './Tax/reducer';
import category from './Category/reducer';
import product from './Product/reducer';
import stockTake from './StockTake/reducer';
import staff from './Staff/reducer';
import salon from './Salon/reducer';
import staffRole from './StaffRole/reducer';
import brand from './Brand/reducer';
import supplier from './Supplier/reducer';
import auth from './Auth/reducer';
import user from './User/reducer';
import appUpdate from './reducers/appUpdate';

const rootReducer = combineReducers({
  tax,
  category,
  product,
  stockTake,
  staff,
  salon,
  staffRole,
  brand,
  supplier,
  auth,
  user,
  appUpdate,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js